(() => {
  'use strict';
  try {
    const node = document.getElementById('tjs-size-demo-config');
    if (!node || node.tjsSize?.ready) return;
    const config = JSON.parse(node.textContent);
    const initial = JSON.parse(document.getElementById('tjs-shopify-public-catalog')?.textContent || '{"products":[]}').products;
    const tjsSize = { ready: true, busy: false };
    const root = config.root || '/';
    const later = 'Not selected';
    const unknown = "I don't know";
    const owner = 'band-size-v1';
    const assert = (condition, message) => { if (!condition) throw Error(message); };
    const rows = () => window.TJSShopifyCatalog?.state?.phase === 'ready' ? [...window.TJSShopifyCatalog.state.products.values()] : initial;
    const record = product => product && (rows().find(row => String(row.id) === String(product.id) || row.handle === product.handle) || (config.current?.handle === product.handle ? config.current : null));
    tjsSize.enabled = product => product?.status === 'active' && product.productType === 'Wedding Bands' && record(product)?.sizeEnabled === true;
    const tiers = new Map();
    for (const tier of config.feeVariantRows || Object.values(config.feeVariants || {})) {
      const key = String(tier.price);
      tiers.set(key, tiers.has(key) ? null : tier);
    }
    const validTier = amount => amount === 0 || (() => {
      const tier = tiers.get(String(amount));
      return tier && /^\d+$/.test(String(tier.id)) && tier.available === true && tier.price === amount;
    })();
    const fees = product => {
      const entry = record(product);
      if (entry?.useSizeFeeRows === true) {
        const result = new Map();
        for (const row of Array.isArray(entry.sizeFeeRows) ? entry.sizeFeeRows : []) {
          const raw = String(row?.size ?? '').trim();
          const numeric = Number(raw);
          if (!raw || !Number.isFinite(numeric) || numeric <= 0 || !Number.isInteger(numeric * 2)) continue;
          const size = String(numeric), charge = String(row?.extraChargeUsd ?? '');
          const cents = Math.round(Number(charge) * 100);
          const amount = /^\d+(?:\.\d{1,2})?$/.test(charge) && Number.isSafeInteger(cents) ? cents : null;
          const valid = /^[1-9][0-9]*(?:\.5)?$/.test(raw) && raw.length <= 6 && amount !== null && validTier(amount);
          result.set(size, result.has(size) || !valid ? null : amount);
        }
        return new Map([...result].sort((x, y) => Number(x[0]) - Number(y[0])));
      }
      const data = entry?.sizeFees;
      assert(data && typeof data === 'object' && !Array.isArray(data), 'Ring size pricing is unavailable. Please contact the studio.');
      const entries = Object.entries(data).map(([size, amount]) => {
        assert(/^\d+(?:\.5)?$/.test(size) && Number(size) > 0 && typeof amount === 'number' && Number.isFinite(amount) && amount >= 0 && Number.isSafeInteger(Math.round(amount * 100)) && Math.abs(amount * 100 - Math.round(amount * 100)) < 0.000001, 'Ring size pricing needs review. Please contact the studio.');
        return [size, Math.round(amount * 100)];
      }).sort((x, y) => Number(x[0]) - Number(y[0]));
      assert(entries.length, 'Ring size pricing is unavailable. Please contact the studio.');
      return new Map(entries);
    };
    const amountFor = (product, size) => {
      if (size === later || size === unknown) return 0;
      const amount = fees(product).get(size);
      assert(Number.isSafeInteger(amount) && amount >= 0 && validTier(amount), 'This ring size or its fee is unavailable. Please choose another size or contact the studio.');
      return amount;
    };
    const error = message => {
      const target = document.querySelector('[data-tjs-size-error]') || document.getElementById('tjs-checkout-message');
      if (target) { if (target.textContent !== message) target.textContent = message; target.classList.add('studio-error'); }
      else if (message && typeof toast === 'function') toast(message);
    };
    tjsSize.options = (product, saved) => {
      if (!tjsSize.enabled(product)) return null;
      let numeric = [];
      try { numeric = [...fees(product)]; } catch (failure) { queueMicrotask(() => error(failure.message)); }
      const value = saved || later;
      return [[later, 'Choose later'], ...numeric.map(([size, fee]) => [size, size, fee === null || !validTier(fee)]), [unknown, unknown]].map(([key, label, disabled]) => '<option value="' + esc(key) + '"' + (key === value ? ' selected' : '') + (disabled ? ' disabled' : '') + '>' + esc(label) + '</option>').join('');
    };
    tjsSize.valid = (product, size) => {
      if (!tjsSize.enabled(product)) return undefined;
      if (size === unknown) return true;
      if (size === later) return false;
      try { return Number.isSafeInteger(amountFor(product, size)); } catch { return false; }
    };
    const choice = item => window.TJS_CATALOG_META?.[item.id]?.variants?.find(variant => String(item.option || '') === variant.label || String(item.option || '').startsWith(variant.label + ' · US size: '));
    const sizeOf = item => String(item.sizeFee?.size || String(item.option || '').split(' · US size: ')[1] || later);
    const owned = line => line.properties?._tjs_size_pricing === owner && !!line.properties._size_link;
    const isFee = line => String(line.product_id) === String(config.helperId);
    const sizeProperty = line => String(line.properties?.['US ring size preference'] || later);
    const keyOf = line => String(line.variant_id ?? line.variantId) + '|' + String(line.properties?._size_link || '') + '|' + sizeProperty(line);
    const linkOf = line => String(line.properties?._size_link || '');
    const linked = item => {
      const product = item.product || getProduct(item.id);
      assert(tjsSize.enabled(product), 'This saved ring size needs review on its product page.');
      const selected = choice(item), size = sizeOf(item), amount = amountFor(product, size);
      assert(selected, 'The selected ring variant has changed. Please choose it again.');
      const variant = record(product)?.variants?.find(value => String(value.id) === String(selected.shopifyVariantId));
      assert(variant && variant.available && Number.isSafeInteger(variant.price) && variant.price > 0, 'This selection is currently unavailable for purchase.');
      const quantity = Number(item.qty);
      assert(Number.isInteger(quantity) && quantity >= 1 && quantity <= 20, 'Choose a quantity from 1 to 20.');
      const link = String(variant.id) + '_' + size;
      const properties = { _tjs_checkout: 'v1', _tjs_size_pricing: owner, _size_link: link, _size_choice: size };
      if (size !== later) properties['US ring size preference'] = size;
      const result = [{ variantId: String(variant.id), handle: product.handle, priceCents: variant.price, quantity, properties }];
      if (amount) {
        const tier = tiers.get(String(amount));
        assert(tier && /^\d+$/.test(tier.id) && tier.available && tier.price === amount, 'The matching ring size fee is unavailable. Nothing was added. Please contact the studio.');
        result.push({ variantId: tier.id, handle: config.helperHandle, priceCents: tier.price, quantity, properties: { _tjs_checkout: 'v1', _tjs_size_pricing: owner, _size_link: link, 'Size fee for': product.title + ' — U.S. ring size ' + size } });
      }
      return result;
    };
    const request = async (path, body) => {
      const response = await fetch(path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}), signal: AbortSignal.timeout(15000) });
      const data = await response.json();
      assert(response.ok, data.description || data.message || 'Unable to update your ring selection. Please retry.');
      return data;
    };
    const read = () => request(root + 'cart.js');
    let pending = Promise.resolve();
    const serial = action => {
      const work = () => window.navigator?.locks ? window.navigator.locks.request('tjs-shopify-cart-v1', action) : action();
      const next = pending.then(work, work); pending = next.catch(() => {}); return next;
    };
    const payload = row => ({ id: Number(row.variantId), quantity: row.quantity, properties: row.properties });
    const verifyVariants = async desired => {
      const products = new Map();
      for (const row of desired) {
        if (!products.has(row.handle)) products.set(row.handle, await request(root + 'products/' + encodeURIComponent(row.handle) + '.js'));
        const variant = products.get(row.handle).variants?.find(value => String(value.id) === row.variantId);
        assert(variant && variant.available, 'A selected ring or size fee is currently unavailable. Please review your selection.');
        assert(Number(variant.price) === row.priceCents, 'A ring or size fee price has changed. Refresh the page before adding to your bag.');
      }
    };
    const verifyRows = (data, desired) => {
      for (const row of desired) {
        const matches = data.items.filter(line => keyOf(line) === keyOf(row));
        assert(matches.length === 1 && matches[0].quantity === row.quantity && matches[0].original_price === row.priceCents && (!row.properties._tjs_size_pricing || owned(matches[0])), 'The ring and size fee could not be verified. Please review your bag before checkout.');
      }
    };
    const syncRows = async desired => {
      let current = await read();
      for (const row of desired) {
        const matches = current.items.filter(line => keyOf(line) === keyOf(row));
        assert(matches.length <= 1, 'Repeated ring selections need review. Please contact the studio.');
        if (matches[0] && matches[0].quantity !== row.quantity) current = await request(root + 'cart/change.js', { id: matches[0].key, quantity: row.quantity });
      }
      current = await read();
      const missing = desired.filter(row => !current.items.some(line => keyOf(line) === keyOf(row)));
      if (missing.length) await request(root + 'cart/add.js', { items: missing.map(payload) });
      const after = await read(); verifyRows(after, desired); return after;
    };
    const restorePairs = async (before, links) => {
      const prior = before.items.filter(line => owned(line) && links.has(linkOf(line)));
      const current = await read();
      for (const line of current.items.filter(value => owned(value) && links.has(linkOf(value)))) {
        const original = prior.find(value => keyOf(value) === keyOf(line));
        await request(root + 'cart/change.js', { id: line.key, quantity: original?.quantity || 0 });
      }
      const restored = await read();
      const missing = prior.filter(line => !restored.items.some(value => keyOf(value) === keyOf(line)));
      if (missing.length) await request(root + 'cart/add.js', { items: missing.map(line => ({ id: line.variant_id, quantity: line.quantity, properties: line.properties })) });
    };
    const transact = async (links, action) => {
      const before = await read();
      try { return await action(before); }
      catch (failure) {
        try { await restorePairs(before, links); }
        catch { throw Error(failure.message + ' Your bag could not be restored automatically; please review it before checkout.'); }
        throw failure;
      }
    };
    tjsSize.normalize = item => {
      if (!tjsSize.enabled(getProduct(item.id))) return null;
      return { id: item.id, option: item.option, qty: item.qty, sizeFee: { size: sizeOf(item) } };
    };
    tjsSize.price = item => {
      if (!tjsSize.enabled(item.product || getProduct(item.id))) return null;
      try { return linked(item).reduce((total, row) => total + row.priceCents, 0) / 100; }
      catch { return null; }
    };
    tjsSize.reconcile = async (data, send, route) => {
      if (!data.items.some(owned)) return data;
      await window.TJSShopifyCatalog?.ready;
      const expected = [];
      for (const line of data.items.filter(value => owned(value) && !isFee(value))) {
        const product = getProduct('shopify-' + line.product_id) || (typeof CATALOG !== 'undefined' && CATALOG.find(value => value.handle === line.handle));
        assert(tjsSize.enabled(product), 'A saved ring size selection is no longer enabled. Please review your bag.');
        const variant = window.TJS_CATALOG_META?.[product.id]?.variants?.find(value => String(value.shopifyVariantId) === String(line.variant_id));
        assert(variant, 'A saved ring variant needs review.');
        const size = String(line.properties._size_choice || sizeProperty(line));
        const pair = linked({ id: product.id, option: variant.label + ' · US size: ' + size, qty: line.quantity, sizeFee: { size } });
        assert(linkOf(pair[0]) === linkOf(line), 'A saved ring size link needs review.');
        expected.push(...pair.slice(1));
      }
      if (expected.length) await verifyVariants(expected);
      const seen = new Set();
      for (const line of data.items.filter(value => owned(value) && isFee(value))) {
        const key = keyOf(line), row = expected.find(value => keyOf(value) === key), duplicate = seen.has(key); seen.add(key);
        if (!row || duplicate || line.quantity !== row.quantity) await send(route + 'cart/change.js', { id: line.key, quantity: row && !duplicate ? row.quantity : 0 });
      }
      let current = await send(route + 'cart.js');
      const missing = expected.filter(row => !current.items.some(line => keyOf(line) === keyOf(row)));
      if (missing.length) await send(route + 'cart/add.js', { items: missing.map(payload) });
      current = await send(route + 'cart.js'); verifyRows(current, expected); return current;
    };
    tjsSize.prepare = async (items, resolve, send, route, approved) => {
      const bands = items.filter(item => tjsSize.enabled(item.product || getProduct(item.id)));
      const others = items.filter(item => !tjsSize.enabled(item.product || getProduct(item.id)));
      const desired = [...bands.flatMap(linked), ...(others.length ? await resolve(others) : [])];
      await verifyVariants(desired);
      let current = await send(route + 'cart.js');
      assert(current.items.every(line => line.properties?._tjs_checkout === 'v1' && !line.selling_plan_allocation), 'Your Shopify bag contains a separate selection that cannot be changed automatically. Please contact the studio.');
      const migrations = [];
      for (const line of current.items.filter(value => !owned(value))) {
        if (desired.some(row => !row.properties._tjs_size_pricing && keyOf(row) === keyOf(line))) continue;
        const match = desired.find(row => row.properties._tjs_size_pricing && row.handle !== config.helperHandle && row.variantId === String(line.variant_id) && sizeProperty(row) === sizeProperty(line) && !line.properties?._size_link);
        assert(match, 'Your Shopify bag contains another selection. Please review it before continuing; nothing will be removed automatically.');
        assert(!current.items.some(value => owned(value) && keyOf(value) === keyOf(match)), 'A previous ring selection needs review before checkout.');
        migrations.push({ line, match });
      }
      for (const { line, match } of migrations) await send(route + 'cart/change.js', { id: line.key, quantity: line.quantity, properties: { ...line.properties, ...match.properties } });
      current = await send(route + 'cart.js');
      for (const line of current.items.filter(owned)) {
        if (!desired.some(row => keyOf(row) === keyOf(line))) await send(route + 'cart/change.js', { id: line.key, quantity: 0 });
      }
      await syncRows(desired);
      current = await send(route + 'cart.js');
      verifyRows(current, desired);
      assert(approved(current) && current.items.length === desired.length, 'Your bag changed. Please review it before checkout.');
      return current;
    };
    const productButtons = id => [...document.querySelectorAll('[data-fc-add],[data-add]')].filter(button => button.dataset.fcAdd === id || button.dataset.add === id);
    tjsSize.add = id => {
      const product = getProduct(id);
      if (!tjsSize.enabled(product)) return false;
      if (tjsSize.busy) return true;
      let item, desired;
      try {
        const selected = TJSFullCatalog.selected(product);
        assert(tjsCanPurchase(product, selected), 'This selection is currently unavailable for purchase.');
        const size = document.querySelector('#ring-size')?.value || builder.catalogSizes?.[id] || later;
        const quantity = 1;
        item = { id, option: selected.label + ' · US size: ' + size, qty: quantity, sizeFee: { size } };
        desired = linked(item);
      } catch (failure) { error(failure.message); return true; }
      if (cart.some(row => row.id === id && row.option === item.option)) {
        save(); bag();
        if (typeof toast === 'function') toast('This selection is already in your cart.');
        return true;
      }
      const buttons = productButtons(id).map(button => ({ button, disabled: button.disabled }));
      buttons.forEach(({ button }) => { button.disabled = true; }); tjsSize.busy = true;
      serial(async () => {
        await verifyVariants(desired);
        const old = cart.find(row => row.id === id && row.option === item.option);
        await transact(new Set(desired.map(linkOf)), async before => {
          const nativeRing = before.items.find(line => owned(line) && keyOf(line) === keyOf(desired[0]));
          if (nativeRing) verifyRows(before, linked({ ...item, qty: nativeRing.quantity }));
          if (nativeRing) {
            assert(nativeRing.quantity === 1, 'Your ring quantity changed in another tab. Please review your bag.');
          } else {
            await request(root + 'cart/add.js', { items: desired.map(payload) });
          }
          item.qty = 1;
          verifyRows(await read(), linked(item));
        });
        if (old) { old.qty = item.qty; old.sizeFee = item.sizeFee; } else cart.push(item);
        save(); bag();
      }).catch(failure => error(failure.message)).finally(() => {
        tjsSize.busy = false;
        buttons.forEach(({ button, disabled }) => { if (button.isConnected) button.disabled = disabled || !tjsCanPurchase(product, TJSFullCatalog.selected(product)); });
      });
      return true;
    };
    const changeQuantity = (index, quantity) => {
      const item = cart[index];
      if (!item || !tjsSize.enabled(getProduct(item.id)) || tjsSize.busy) return;
      tjsSize.busy = true;
      serial(async () => {
        const selected = choice(item);
        assert(selected, 'This ring selection needs review.');
        const link = String(selected.shopifyVariantId) + '_' + sizeOf(item);
        await transact(new Set([link]), async before => {
          if (!quantity) {
            for (const line of before.items.filter(value => owned(value) && linkOf(value) === link)) await request(root + 'cart/change.js', { id: line.key, quantity: 0 });
          } else {
            const desired = linked({ ...item, qty: quantity });
            await verifyVariants(desired); await syncRows(desired);
          }
        });
        if (!quantity) cart.splice(index, 1); else item.qty = quantity;
        save();
      }).catch(failure => error(failure.message)).finally(() => { tjsSize.busy = false; });
    };
    const checkedCarts = new WeakSet();
    const mount = () => {
      try {
        const cartRoot = document.querySelector('[data-cart-page]');
        if (cartRoot && !checkedCarts.has(cartRoot)) {
          checkedCarts.add(cartRoot);
          serial(async () => tjsSize.reconcile(await read(), request, root)).catch(failure => error(failure.message));
        }
        const pdp = document.querySelector('[data-fc-product]');
        const product = pdp && getProduct(pdp.dataset.fcProduct);
        if (!pdp || !tjsSize.enabled(product)) return;
        pdp.dataset.tjsSizeEnabled = '';
        const dropdown = pdp.querySelector('#ring-size');
        if (!dropdown) return;
        if (!pdp.querySelector('[data-tjs-size-error]')) {
          const status = document.createElement('p'); status.dataset.tjsSizeError = ''; status.className = 'studio-error'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
          (dropdown.closest('.fc-size') || dropdown).after(status);
        }
        const variant = TJSFullCatalog.selected(product);
        const nativeVariant = record(product)?.variants?.find(value => String(value.id) === String(variant.shopifyVariantId));
        assert(nativeVariant && Number.isSafeInteger(nativeVariant.price), 'The ring price needs review.');
        const price = pdp.querySelector('.fc-pdp-price');
        const fee = amountFor(product, dropdown.value || later);
        if (fee) {
          const tier = tiers.get(String(fee));
          assert(tier && tier.available && tier.price === fee, 'The matching ring size fee is unavailable. Please contact the studio.');
        }
        const amount = nativeVariant.price + fee;
        const text = currency(amount / 100);
        if (price && price.textContent !== text) price.textContent = text;
      } catch (failure) { error(failure.message); }
    };
    node.tjsSize = tjsSize;
    document.addEventListener('click', event => {
      try { const remove = event.target.closest('[data-tjs-size-remove]'); if (remove) { event.preventDefault(); changeQuantity(Number(remove.dataset.tjsSizeRemove), 0); } }
      catch (failure) { error(failure.message); }
    });
    document.addEventListener('change', event => {
      try {
        if (event.target.id === 'ring-size' && tjsSize.enabled(getProduct(event.target.closest('[data-fc-product]')?.dataset.fcProduct))) { error(''); mount(); }
      } catch (failure) { error(failure.message); }
    });
    let queued = false;
    const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; mount(); }); };
    new MutationObserver(schedule).observe(document.getElementById('main') || document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('DOMContentLoaded', schedule); window.addEventListener('hashchange', schedule); schedule();
  } catch (failure) { console.warn('TJS band size pricing could not start:', failure); }
})();
